var _a, _b;
import { BillingGatewayRegion } from '../services/Environment';
// RFC 5646 / IETF Language Tag
export var Locale;
(function (Locale) {
    Locale["US"] = "en-US";
    Locale["UK"] = "en-GB";
    Locale["JP"] = "ja-JP";
    Locale["enAU"] = "en-AU";
    Locale["enSG"] = "en-SG";
    Locale["msMY"] = "ms-MY";
    Locale["enTH"] = "en-TH";
    Locale["thTH"] = "th-TH";
})(Locale || (Locale = {}));
// ISO 15897
export var getTraditionalLocale = function (locale) {
    if (locale === void 0) { locale = Locale.US; }
    return locale.replace('-', '_');
};
export var SupportedVendors;
(function (SupportedVendors) {
    SupportedVendors["adyen"] = "adyen";
    SupportedVendors["braintree"] = "braintree";
})(SupportedVendors || (SupportedVendors = {}));
// values are based on Chrome Developer Tools
export var ScreenWidths;
(function (ScreenWidths) {
    ScreenWidths[ScreenWidths["Web_1428"] = 1428] = "Web_1428";
    ScreenWidths[ScreenWidths["Tablet_724"] = 724] = "Tablet_724";
    ScreenWidths[ScreenWidths["Tablet_520"] = 520] = "Tablet_520";
    ScreenWidths[ScreenWidths["Phone_412"] = 412] = "Phone_412";
    ScreenWidths[ScreenWidths["Phone_360"] = 360] = "Phone_360"; // Samsung S8+
})(ScreenWidths || (ScreenWidths = {}));
export var InlineMaxCardsLarge = 4;
export var InlineMaxCardsMedium = 3;
export var InlineMaxCardsSmall = 2;
export var TooltipRowMaxCards = 3;
export var AdyenCheckoutErrors;
(function (AdyenCheckoutErrors) {
    AdyenCheckoutErrors["CANCEL"] = "CANCEL";
})(AdyenCheckoutErrors || (AdyenCheckoutErrors = {}));
export var CardBrandUrlPath = 'https://cdf6519016.cdn.adyen.com/checkoutshopper/images/logos/';
export var SupportedVendorsList = Object.values(SupportedVendors);
export var VendorBrandMapping = (_a = {},
    _a[SupportedVendors.braintree] = {
        'American Express': 'amex',
        Discover: 'discover',
        JCB: 'jcb',
        Mastercard: 'mc',
        Visa: 'visa',
        UnionPay: 'unionpay',
        'master-card': 'mc',
        'american-express': 'amex',
        discover: 'discover',
        jcb: 'jcb',
        visa: 'visa',
        unionpay: 'unionpay',
        meastro: 'maestro',
        'diners-club': 'diners',
        elo: 'elo',
        mir: 'mir',
        hiper: 'hiper',
        hipercard: 'hipercard'
    },
    _a);
export var AdyenEnvironmentMapping = (_b = {},
    _b[BillingGatewayRegion.US] = 'live-us',
    _b[BillingGatewayRegion.EU] = 'live',
    _b[BillingGatewayRegion.APAC] = 'live-apse',
    _b);
var BaseComponentId;
(function (BaseComponentId) {
    BaseComponentId["button"] = "button";
    BaseComponentId["input"] = "input";
    BaseComponentId["checkbox"] = "checkbox";
    BaseComponentId["dropdown"] = "dropdown";
    BaseComponentId["label"] = "label";
    BaseComponentId["container"] = "container";
})(BaseComponentId || (BaseComponentId = {}));
// to be used for automation
export var ComponentId = {
    // buttons
    BUTTON_GOOGLE_PAY: "".concat(BaseComponentId.button, "-googlePay"),
    BUTTON_PAYPAL: "".concat(BaseComponentId.button, "-paypal"),
    BUTTON_SUBMIT_PAYMENT: "".concat(BaseComponentId.button, "-submitPayment"),
    // text inputs
    INPUT_CARDHOLDER_NAME: "".concat(BaseComponentId.input, "-cardHolderName"),
    INPUT_CARD_NUMBER: "".concat(BaseComponentId.input, "-cardNumber"),
    INPUT_CARD_EXPIRATION: "".concat(BaseComponentId.input, "-cardExpiration"),
    INPUT_CVV: "".concat(BaseComponentId.input, "-cvv"),
    INPUT_ADDRESS_LINE1: "".concat(BaseComponentId.input, "-addressLine1"),
    INPUT_ADDRESS_LINE2: "".concat(BaseComponentId.input, "-addressLine2"),
    INPUT_CITY: "".concat(BaseComponentId.input, "-city"),
    INPUT_ZIPCODE: "".concat(BaseComponentId.input, "-zipCode"),
    // checkboxes
    CHECKBOX_SAME_AS_BILLING_ADDRESS: "".concat(BaseComponentId.checkbox, "-sameAsBillingAddress"),
    // dropdowns
    DROPDOWN_STATE: "".concat(BaseComponentId.dropdown, "-state"),
    // labels
    LABEL_EXPRESSPAY_DIVIDER: "".concat(BaseComponentId.label, "-expressPayDivider"),
    // containers
    CONTAINER_CARD_BRANDS: "".concat(BaseComponentId.container, "-cardBrands")
};
